import { SpecialsListingComponent } from "./components/specials-listing/specials-listing.component";
import { Routes } from "@angular/router";

export const specialsRoutes: Routes = [
  { path: "", component: SpecialsListingComponent },
];
